import PropTypes from 'prop-types';
import React from 'react';
import { map } from 'lodash';
import { Grid, Row, Col, FormGroup, ControlLabel, FormControl, } from 'react-bootstrap';
import accounting from 'accounting';
import { getCurrencySymbol } from 'components/modules/master/formatters';
const Units = [
    {
        name: 'Day',
        value: 'day',
    },
    {
        name: 'Hour',
        value: 'hour',
    },
    {
        name: 'Minute',
        value: 'minute',
    },
];
export default class AccessorialRatesTimeBaseEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = { accessorialRate: this.props.accessorialRate || {} };
    }
    onChange(property, e, isNumber) {
        const value = e.target.value;
        const accessorialRate = this.state.accessorialRate;
        accessorialRate[property] = value;
        this.setState({ accessorialRate: accessorialRate });
        this.props.onChange(property, isNumber ? Number(value) : value);
        const unit = accessorialRate.unit;
        let description = `${accounting.formatMoney(accessorialRate.rate, getCurrencySymbol(DEFAULT_CURRENCY))} per ${unit}. `;
        description +=
            accessorialRate.free && accessorialRate.free > 0
                ? `First ${accessorialRate.free} ${unit}(s) for free. `
                : '';
        description +=
            accessorialRate.minimum_number && accessorialRate.minimum_number > 0
                ? `With ${accessorialRate.minimum_number} ${unit}(s) minimum. `
                : '';
        description +=
            accessorialRate.increment && accessorialRate.increment > 0
                ? `Increase by ${accessorialRate.increment} ${unit}(s). `
                : '';
        this.props.onChange('description', description);
    }
    handleRateChange() {
        return (e) => {
            this.onChange('rate', e, true);
        };
    }
    handleFreeChange() {
        return (e) => {
            this.onChange('free', e, true);
        };
    }
    handleMinNumberChange() {
        return (e) => {
            this.onChange('minimum_number', e, true);
        };
    }
    handleUnitChange() {
        return (e) => {
            this.onChange('unit', e, false);
        };
    }
    handleIncrementChange() {
        return (e) => {
            this.onChange('increment', e, true);
        };
    }
    validateRate(rate) {
        if (rate > 0) {
            return '';
        }
        return 'error';
    }
    validateValue(value) {
        if (value >= 0) {
            return '';
        }
        return 'error';
    }
    render() {
        const accessorialRate = this.state.accessorialRate;
        return (React.createElement(Grid, { fluid: true },
            React.createElement(Row, { className: "show-grid" },
                React.createElement(Col, { xs: 4 },
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, accessorialRate.name),
                        React.createElement(FormControl, { type: "number", defaultValue: accessorialRate.rate, onChange: this.handleRateChange(), bsStyle: this.validateValue(accessorialRate.rate) })),
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, `${accessorialRate.unit}s for free`),
                        React.createElement(FormControl, { type: "number", defaultValue: accessorialRate.free, onChange: this.handleFreeChange(), bsStyle: this.validateValue(accessorialRate.free) })),
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, `Minimum ${accessorialRate.unit}s for charge`),
                        React.createElement(FormControl, { type: "number", defaultValue: accessorialRate.minimum_number, onChange: this.handleMinNumberChange(), bsStyle: this.validateValue(accessorialRate.minimum_number) }))),
                React.createElement(Col, { xs: 1 },
                    React.createElement("div", { calssName: "form-group", style: { marginTop: 30 } },
                        React.createElement("label", null, `${getCurrencySymbol(DEFAULT_CURRENCY)} per`))),
                React.createElement(Col, { xs: 4 },
                    React.createElement(FormGroup, null,
                        "\u00A0",
                        React.createElement(FormControl, { componentClass: "select", defaultValue: accessorialRate.unit, onChange: this.handleUnitChange() }, map(Units, (unit, index) => (React.createElement("option", { value: unit.value, key: `unit-${index}` }, unit.name))))),
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, `${accessorialRate.unit}s for increment`),
                        React.createElement(FormControl, { type: "number", defaultValue: accessorialRate.increment, onChange: this.handleIncrementChange(), bsStyle: this.validateValue(accessorialRate.increment) }))))));
    }
}
AccessorialRatesTimeBaseEditor.propTypes = {
    accessorialRate: PropTypes.object,
    onChange: PropTypes.func,
};
